import { render, staticRenderFns } from "./innovate.vue?vue&type=template&id=0419bb08&scoped=true&"
import script from "./innovate.vue?vue&type=script&lang=js&"
export * from "./innovate.vue?vue&type=script&lang=js&"
import style0 from "./innovate.vue?vue&type=style&index=0&id=0419bb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419bb08",
  null
  
)

export default component.exports